import { motion } from "framer-motion";
import { TRUSTED } from "./assets";

export default function TrustedAffiliated() {
  return (
    <section
      id="trusted"
      data-testid="trusted-section"
      className="py-24 md:py-32 bg-black text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
            Network
          </p>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            Trusted & Affiliated
          </h2>
          <p className="mt-6 text-white/55 text-lg leading-relaxed">
            Proudly connected with coaches, schools, athletes, and performance
            organizations across the Ohio Valley and beyond.
          </p>
        </motion.div>

        <div className="flex flex-wrap items-start justify-center gap-8">
          {TRUSTED.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`trusted-logo-${i}`}
              className="group flex flex-col items-center text-center w-[280px]"
            >
              <div className="flex items-center justify-center w-full h-[240px]">
                <img
                  src={t.src}
                  alt={t.full || t.name}
                  loading="lazy"
                  className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <p className="font-display font-bold uppercase tracking-tight text-xl mt-4 leading-tight">
                {t.full}
              </p>
              <p className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/45 mt-2">
                {t.location}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
